import axios from "axios";
import { apiEndpoint, isAxioMock } from "utils/configs";
import AxiosMockAdapter from "axios-mock-adapter";

const axiosMockInstance = axios.create();
const axiosLiveInstance = axios.create({
  baseURL: apiEndpoint,
  withCredentials: true,
});

const axiosMockAdapterInstance = new AxiosMockAdapter(axiosMockInstance, {
  delayResponse: 0,
});

const axiosInstance = isAxioMock === "true" ? axiosMockInstance : axiosLiveInstance;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.location.href =
        process.env.REACT_APP_ACCOUNTS_URL || "https://accounts-internal.fizen.io";
      return;
    }
    return Promise.reject(
      (error.response &&
        error.response.data && {
          message: error.response.data.description,
          ...error.response.data,
        }) ||
        error ||
        "Something went wrong",
    );
  },
);
export { axiosInstance, axiosMockAdapterInstance };

export * from "./chains";
/* PLOP_APIS_IMPORT */
export * from "./operationwalletmanagement";
export * from "./operatingwalletlog";
export * from "./whitelist";
export * from "./testwithrole";
export * from "./systemwithdrawhistorylog";
export * from "./adminmanagement";
export * from "./systembalances";
export * from "./setting";
export * from "./unmatchedpayment";
export * from "./anhvinh";
export * from "./withdrawalhistory";
export * from "./charges";
export * from "./payments";
export * from "./cryptocurrency";
export * from "./registeremail";
export * from "./merchants";
